<template>
    <div class="modal fade" id="addLecturersModal" role="dialog" aria-labelledby="addLecturersModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="addLecturersModalLabel">{{$t('buttons.addLecturers.action')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <div v-else class="modal-body" :id="conatinerId">
                    <div class="card border-primary mb-3">
                        <h5 class="card-header text-primary"><i class="fas fa-user-edit mr-2"></i>{{model.name}}</h5>
                        <div class="card-body">
                            <div class="form-row">
                                <div class="form-group col-sm-12 col-md-6">
                                    <label class="font-weight-bold">
                                        {{$t('registers.forms.gridHeaders.formType')}}
                                    </label>

                                    <input class="form-control" type="text" :value="model.formType" readonly>
                                </div>

                                <div class="form-group col-sm-12 col-md-6">
                                    <label class="font-weight-bold">
                                        {{$t('registers.forms.gridHeaders.eventName')}}
                                    </label>

                                    <input class="form-control" type="text" :value="model.eventName" readonly>
                                </div>
                            </div>
                             <!-- {{model}}
                             <hr />
                             {{ lecturers }} -->

                             <div class="table-responsive">
                                 <table class="table table-sm" v-if="lecturers && lecturers.length > 0">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>{{ $t('registers.events.participants.gridHeaders.name') }}</th>
                                            <th>{{ $t('registers.events.participants.gridHeaders.email') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(lecturer, index) in lecturers" :key="index">
                                            <td>
                                                <vs-checkbox
                                                    v-model="lecturer.checked"
                                                    :name="'checked' + _uid"
                                                    :id="'checked' + _uid"
                                                    style="justify-content: flex-start !important">
                                                </vs-checkbox>
                                            </td>
                                            <td v-if="isEnVersion">{{ lecturer.fullNameEn }}</td>
                                            <td v-else>{{ lecturer.fullName }}</td>
                                            <td>{{ lecturer.email }}</td>
                                        </tr>
                                    </tbody>
                                 </table>

                             </div>

                            <div class="text-right mt-3">
                                <div class="btn-group" role="group" aria-label="Form to Event buttons">
                                    <button type="button" class="btn btn-success" @click.stop="onSave"><i class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}</button>
                                    <button type="button" class="btn btn-danger" @click.stop="onCancel"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { FormToEven } from '@/models/models';
    import formSurverService from '@/services/formSurvey.service';
    import { mapGetters } from 'vuex';

    export default {
        components: {
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                model: new FormToEven(),
                lecturers: null,
                isSaving: false,
                conatinerId: 'lecturers-add-container',
                popup: {
                    appendTo: $("#" + this.conatinerId)
                }
            };
        },
        methods: {
            loadLecturers() {
                this.isSaving = true;
                formSurverService
                    .lecturers(this.model.id)
                    .then(response => {
                        if (response.data) {
                            this.lecturers = response.data;
                        } else {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                text: this.$helpers.responseMessage(response),
                                color: 'warning',
                                time: this.$store.getters.notificationDuration
                            });
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            },
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new FormToEven();
                this.lecturers = null;
                this.isSaving = false;
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave() {
                this.isSaving = true;

                formSurverService
                    .addLecturers(this.lecturers)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit('onAdd', this.lecturers);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .finally(() => {
                        this.onClose();
                    });
            },
            onCancel() {
                this.onClose();
            },
        },
        mounted() {
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            $(this.$el).off('hidden.bs.modal');
        },
        computed: {
            ...mapGetters(['participationRequestNameEn', 'isEnVersion']),
            isParticipationRequestForm() {
                return this.model.formTypeEn === this.participationRequestNameEn
            },
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new FormToEven(this.value);
                    $(this.$el).modal('show');
                    this.loadLecturers()
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>
